import React, { useState, useEffect } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { Panel, Icon, Form, Col, Button, Message, Checkbox } from 'rsuite'
import { useForm, Controller } from 'react-hook-form'
import TextareaRadioForm from '../../components/forms/textareaRadioForm/TextareaRadioForm'
import { startLoading, doneLoading } from '../../utils/loading'
import { saveApproveProject } from '../../redux/actions/approveProject'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { Link } from 'react-router-dom'
import CoiApproveProjectWidget from '../coi/CoiApproveProjectWidget'

export default function LawApproveProposal({
  schema,
  projectVersionId,
  onComplete,
  approverComment,
}) {
  const history = useHistory()
  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const [isLoading, setIsLoading] = useState(false)
  const [errorMessage, setErrorMessage] = useState(false)
  const [isShowConfimModalOffering, setIsShowConfimModalOffering] = useState(false)
  const [isShowConfimModalEdit, setIsShowConfimModalEdit] = useState(false)
  const { register, handleSubmit, errors, control, setValue, setError, clearErrors, watch } =
    useForm()

  const [formSchema, setFormSchema] = useState(schema)

  console.log('schemaschemaschema *-*-* ', schema)

  return (
    <>
      <Form fluid>
        <Panel
          shaded
          header={formSchema.headerApproveProposal}
          bordered
          collapsible
          defaultExpanded
        >
          {approverComment?.length > 0 &&
            approverComment.map((item, index) => {
              return (
                item.label != 'ความเห็นของนักวิชาการผู้เสนออนุมัติ' && (
                  <Message
                    key={index}
                    type={'info'}
                    description={`${item.label} : ${item.value}`}
                  />
                )
              )
            })}

          <>
            {formSchema.alert && (
              <>
                <Message showIcon type="warning" description={formSchema.alert} />
                <br />
              </>
            )}
            <TextareaRadioForm
              schema={formSchema}
              register={register}
              Controller={Controller}
              control={control}
              errors={errors}
              setValue={setValue}
              clearErrors={clearErrors}
            />

            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              <Button
                style={{ width: 160 }}
                // appearance="ghost"
                color="rgb(45, 168, 136)"
                appearance="primary"
                // onClick={handleSubmit(onSubmitOfferingApproveProposal)}
                // disabled={formSchema.disabled || isLoading }
              >
                {formSchema.buttonOfferingApproveProposalLabel}
              </Button>
            </Col>
            <Col style={{ marginBottom: 20, textAlign: 'right' }} xs={24} sm={24} md={24} lg={24}>
              <Button
                style={{ width: 160 }}
                appearance="ghost"
                // onClick={handleSubmit(onSubmitSendToEdit)}
                icon={<Icon appearance="ghost" icon="edit" />}
                // disabled={formSchema.disabled || isLoading}
              >
                {formSchema.buttonSendEditProposalLabel}
              </Button>
            </Col>
          </>
        </Panel>
        <ConfirmWidget
          title={`ยืนยัน${formSchema.buttonOfferingApproveProposalLabel}`}
          show={isShowConfimModalOffering}
          detail={`กรุณายืนยัน${formSchema.buttonOfferingApproveProposalLabel}`}
          // onCancle={() => setIsShowConfimModalOffering(false)}
          // onConfirm={handleSubmit(handleOnConfirmModalOffering)}
        />
      </Form>
    </>
  )
}
